// extracted by mini-css-extract-plugin
export default {"box":"PayLinkModal_box__g0sZp","boxActive":"PayLinkModal_boxActive__Jhz3K","circle":"PayLinkModal_circle__QcC1c","circleActive":"PayLinkModal_circleActive__MINGg"};